import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import { appTitle, showSize } from "src/components/common/functions";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, MyFormData, 
    mimeTypeMap, mimeTypeMapReverse, 
    boolAndReducer, getTimeStamp, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Documents({rootFolderId, tabTitle}){
    const user = useMyStore(state => state.user);

    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    const path3 = decodeURIComponent(path.split("/")[3] ?? "");

    const location = useLocation();
    const folderId = location.pathname.split("/")[2] || rootFolderId;
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [renderSwith, setRenderSwitch] = useState(true);
    const [showLoading, setShowLoading] = useState(false);

    const [parentFolder, setParentFolder] = useState([{name: path1}]);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = userList.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const curFolderId = location.pathname.split("/")[2] || rootFolderId;
            const formData = new MyFormData();
            formData.append("folderId", curFolderId);
            formData.append("rootFolderId", rootFolderId);
            if(curFolderId !== rootFolderId){
                formData.append("NotRoot", "Yes");
            }
            //------------------------
            setShowLoading(true);
            const res = await myAxios("common/readDocFolder.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //------------------------
            if(curFolderId !== rootFolderId){
                res.data[1].reverse();
                setParentFolder(res.data[1]);
                setUserList(res.data[0]);
            }else{
                history.push(`/${path1}`);
                setUserList(res.data);
                setParentFolder([{name: path1}]);
            }
        }
        getData()
        return () => {isMounted = false}
    }, [renderSwith, location.pathname, history, rootFolderId, path1, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {user.projects !== "no"?<>
                <label htmlFor = "file" className = "pointer">Add File</label>
                <input
                        id = "file"
                        type = "file"
                        multiple
                        className = "nodisplay"
                        onChange = {async e => {
                            const formData = new MyFormData();
                            const target = e.currentTarget;
                            for(let f of target.files){
                                formData.append("files[]", f);
                            }
                            formData.append("folderId", folderId);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios("common/createFiles.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            //setShowLoader(false);
                            setRenderSwitch(s => !s);
                            target.value = "";
                        }}
                    />
                <span className = "pointer" onClick = {async() => {
                    let folderName = window.prompt("Folder Name: ");
                    if(folderName === null) return;
                    while(folderName === ""){
                        window.alert("Folder Name can not be empty.");
                        folderName = window.prompt("Folder Name: ");
                        if(folderName === null) return;
                    }
                    const formData = new MyFormData();
                    formData.append("parentFolderId", folderId);
                    formData.append("folderName", folderName);
                    //------------------------
                    setShowLoader(true);
                    const res = await myAxios("common/createFolder.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //------------------------
                    setRenderSwitch(s => !s);
                }}>
                    Add Folder
                </span>
                <span className = "pointer" onClick = {async() => {
                    let linkName = window.prompt("The name of the Link: ");
                    if(linkName === null) return;
                    while(linkName === ""){
                        window.alert("The name can not be empty.");
                        linkName = window.prompt("The name of the Link: ");
                        if(linkName === null) return;
                    }
                    let linkAddress = window.prompt("The address of the Link: ");
                    if(linkAddress === null) return;
                    while(linkAddress === ""){
                        window.alert("The address can not be empty.");
                        linkAddress = window.prompt("The address of the Link: ");
                        if(linkAddress === null) return;
                    }
                    const formData = new MyFormData();
                    formData.append("parentFolderId", folderId);
                    formData.append("linkName", linkName);
                    formData.append("linkAddress", linkAddress);
                    //----------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("common/createLink.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //----------------------------------------------------
                    setRenderSwitch(s => !s);
                }}>
                    Add Link
                </span>
                </>
                :null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <>
                <div className = "m-3 font-weight-bold text-success">
                    Folder:
                    <span className = "ml-2">
                        {parentFolder.map((f, fi) => <span 
                        key = {fi} 
                        style = {{cursor:"pointer"}} 
                        onClick = {() => {
                            if(!f.id) return;
                            if(f.id === rootFolderId){
                                history.push(`/${path1}`);
                            }else{
                                history.push(`/${path1}/${f.id}`);
                            }
                        }}>{f.name}</span>).reduce((a, b) => [a, <span key = {b.key + "reduce"}> &rarr; </span>, b, ""])}
                    </span>
                </div>
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Size</th>
                                {user.projects !== "no"?<><th></th><th></th></>:null}
                            </tr>
                        </thead>
                        <tbody>
                            {currentUserList.map((doc, key) =>
                            <tr key = {key} id = {doc.id} style = {{cursor:"pointer"}}>
                                {doc.mimeType === mimeTypeMap.folder?
                                <>
                                <td>
                                    <span
                                        style = {{
                                            color: "blue", 
                                            fontWeight: 650
                                        }}
                                        onClick = {() => {
                                            history.push(`/${path1}/${doc.id}`);
                                        }}
                                    >
                                        {doc.name}
                                    </span>
                                </td>
                                <td>folder</td>
                                <td></td>
                                </>
                                :
                                doc.description?
                                <>
                                <td><a href = {doc.description} target = "_blank" rel = "noreferrer">{doc.name}</a></td>
                                <td>Link</td>
                                <td></td>
                                </>
                                :
                                <>
                                <td><a href = {doc.webViewLink} target = "_blank" rel = "noreferrer">{doc.name}</a></td>
                                <td>{doc.mimeType in mimeTypeMapReverse?mimeTypeMapReverse[doc.mimeType]:doc.mimeType}</td>
                                <td>{showSize(doc.size)}</td>
                                </>
                                }
                                {user.projects !== "no"?<td><span className = "btn btn-info" onClick = {async() => {
                                    let fileName = window.prompt("Name:");
                                    if(fileName === null) return;
                                    while(fileName === ""){
                                        window.alert("The name cannot be empty.");
                                        fileName = window.prompt("Name:");
                                        if(fileName === null) return;
                                    }
                                    const formData = new MyFormData();
                                    formData.append("fileId", doc.id);
                                    formData.append("fileName", fileName);
                                    //----------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("common/renameFile.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //----------------------------------------------------
                                    //setShowLoader(false);
                                    setRenderSwitch(s => !s);
                                }}>Rename</span></td>:null}
                                {user.projects !== "no"?<td><span className = "btn btn-danger" onClick = {async() => {
                                    if(!window.confirm("Are you sure to delete this document?")) return;
                                    const formData = new MyFormData();
                                    formData.append("fileId", doc.id);
                                    //----------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("common/deleteFile.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //----------------------------------------------------
                                    setRenderSwitch(s => !s);
                                }}>Delete</span></td>:null}
                            </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                </>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}